import { Component } from '@angular/core';
import { EntryService } from 'src/app/services/entry.service';
import { LocaleService } from '../../localization/locale.service';
import { IEntryDefaultPage } from 'src/rest-interfaces/IEntryDefautlPage';
import { ActivatedRoute } from '@angular/router';
import { ILocalizedComponent } from 'src/app/ILocalizedComponent';
import { Title } from '@angular/platform-browser';
import { generalAnimations } from 'src/app/_animations/general.animations';

@Component( {
  selector: 'app-default-page',
  templateUrl: './default-page.component.html',
  animations: [ generalAnimations ]
} )
export class DefaultPageComponent implements ILocalizedComponent {
  public content: IEntryDefaultPage;

  constructor(
    private entrySvc: EntryService,
    private localeSvc: LocaleService,
    private route: ActivatedRoute,
    private title: Title
  ) {
    this.route.url.subscribe(
      params => {
        // console.log( 'route param changed', params );
        this.entrySvc.uri(
          this.localeSvc.RouterUri
        ).subscribe(
          t => {
            this.content = t;
            this.title.setTitle( 'PIRMIN JUNG - ' + ( typeof t.metaTitle === 'string' && t.metaTitle.length > 0 ? t.metaTitle : t.title ) );
          },
          () => { this.localeSvc.navigateToHome(); }
        );
      }
    );
  }

  public getLocaleChangeUrl( targetLocale: string ): string {
    const locUrlProperty = 'url_' + targetLocale;
    if ( this.content && this.content.hasOwnProperty( locUrlProperty ) ) {
      return this.content[ locUrlProperty ];
    }
  }
}
